import { AnimationProvider, Card, CarouselSection, Text } from '@/components';
import { CarouselScreenProps } from '@/interfaces';
import { MESSAGES } from '@/utils/strings';
import { AnimatePresence } from 'framer-motion';
import Image from 'next/image';
import { FC, useEffect, useState } from 'react';
interface Props {
  children: React.ReactNode;
}
export interface ISlide {
  url: string;
  title: string;
  body: string;
}
const AuthenticationTemplate: FC<Props> = ({ children }) => {
  const [slides, setSlides] = useState<CarouselScreenProps[]>([]);
  const loadSlides = () => {
    const { SLIVER_VALUE_PROPOSITION_CAROUSEL } = MESSAGES;
    const formattedSlides = Object.values(
      SLIVER_VALUE_PROPOSITION_CAROUSEL,
    ).map((slide, index) => ({
      body: (
        <div className="flex flex-col h-full justify-center items-center">
          <div className="flex items-center justify-center pb-12">
            <Image
              src={slide.ILLUSTRATION_URL}
              alt={slide.TITLE}
              className="object-contain h-full w-auto"
              width={100}
              height={100}
              priority={index < 3}
            />
          </div>
          <div className="flex-none flex items-end justify-end pb-3">
            <Text size="h3" color="accent">
              {slide.TITLE}
            </Text>
          </div>
          <div className="flex-none flex items-start justify-center">
            <Text color="secondary">{slide.DECRIPTION}</Text>
          </div>
        </div>
      ),
    }));
    setSlides(formattedSlides);
  };
  useEffect(() => {
    loadSlides();
  }, []);
  return (
    <div className="grid place-items-center w-screen h-screen p-md">
      <Card className="w-[95%] aspect-[4/3] h-[95%] max-w-[1200px] max-h-[900px] p-md gap-md grid grid-cols-[minmax(300px,1fr)_minmax(300px,1fr)] overflow-hidden scrollbar-hide min-w-[600px]">
        <div className="flex justify-center items-center w-full h-full p-md">
          {slides?.length ? (
            <CarouselSection
              screens={slides}
              showNavigationControlsInHeader={false}
              autoNavigate={true}
              autoNavigateInterval={10000}
              className="w-full"
              isBackgroundTransparent={true}
              isBorderTransparent={true}
            />
          ) : null}
        </div>
        <div className="flex justify-center items-center w-full h-full p-md min-w-[300px] overflow-auto">
          <AnimationProvider>
            <AnimatePresence mode="wait">{children}</AnimatePresence>
          </AnimationProvider>
        </div>
      </Card>
    </div>
  );
};
export default AuthenticationTemplate;
